module.exports = __webpack_public_path__ + "img/xml_attr.442fb0bb.png";